import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hiBob = defineConnector({
  identifier: "hiBob",
  name: "HiBob",
  tagLine: "HR management platform",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://api\\.hibob\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.serviceUserId,
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Create an API token in HiBob",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to HiBob and navigate to **Settings > Integrations > API Access** to generate a service user API token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Service user ID",
          required: true,
          target: { kind: "configuration", field: "serviceUserId" },
          helperText: "The service user ID from the API access page.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.hibob.com/v1/company/people",
  },
});
